/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

import * as firebase from 'firebase';

import axios from 'axios';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: null,
    users: [],
    appointments: [],
    submission: {},
    submissions: [],
    submissionIndex: -1,
    notes: [],
    offers: [],
    loading: false,
    error: null,
    uploading: false,
    uploadProgress: 0
  },
  getters: {
    notes(state) {
      return state.notes
    },
    user(state) {
      return state.user
    },
    users(state) {
      return state.users
    },
    appointments(state) {
      return state.appointments
    },
    submissions(state) {
      return state.submissions
    },
    submissionIndex(state) {
      return state.submissionIndex
    },
    submission(state) {
      return state.submission
    },
    offers(state) {
      return state.offers
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    uploading (state) {
      return state.uploading
    },
    uploadProgress (state) {
      return state.uploadProgress
    }
  },
  mutations: {
    setOffers(state, payload) {
      state.offers = payload
    },
    unsetOffers(state, payload) {
      firebase.database().ref('offers/'+payload).off('value') // detach callback previously set on fetch
      state.offers = []
    },
    addOffer(state, payload) {
      let ts = firebase.database.ServerValue.TIMESTAMP;
      payload.created = ts
      payload.user = state.user.uid
      let newPostKey = firebase.database().ref('offers/'+state.submission.uid).push().key
      firebase.database().ref('offers/'+state.submission.uid + '/' + newPostKey).set(payload)
    },
    setNotes(state, payload) {
      state.notes = payload
    },
    unsetNotes(state, payload) {
      firebase.database().ref('notes/'+payload).off('value') // detach callback previously set on fetch
      state.notes = []
    },
    addNote(state, payload) {
      let ts = firebase.database.ServerValue.TIMESTAMP;
      payload.created = ts
      let newPostKey = firebase.database().ref('notes/'+state.submission.uid).push().key
      firebase.database().ref('notes/'+state.submission.uid + '/' + newPostKey).set(payload)
    },
    setUser (state, payload) {
      state.user = payload
    },
    setUsers (state, payload) {
      state.users = payload
    },
    setAppointments (state, payload) {
      state.appointments = payload
    },
    setSubmissions (state, payload) {
      state.submissions = payload
    },
    setSubmission (state, payload) {
      state.submission = payload.submission
      state.submissionIndex = payload.index
      state.submission.tempSubmissionStatus = state.submission.status
    },
    unsetSubmission (state) { // new
      state.submission = {}
      state.submissionIndex = -1
    },
    setSubmissionStatus (state, payload) {
        state.submission.status = payload
        state.submission.user = state.user.uid
        state.submission.tempSubmissionStatus = payload
    },
    setTempSubmissionStatus (state, payload) {
      state.submission.tempSubmissionStatus = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setUploading (state, payload) {
      state.uploading = payload
    },
    setUploadProgress (state, payload) {
      state.uploadProgress = payload
    },
    setAvatarUrl (state, payload) {
      state.user.picUrl = payload
    }
  },

  actions: {
    // APPOINTMENTS
    fetchAppointments({commit, state}) {
      return new Promise(function(resolve, reject) {
        console.log('Fetching Appointments...')
        firebase.database().ref('appointments').on('value', snapshot => {
          //convert subsmissions from firebase to local array (utility function)
          let appointmentsArray = snapshotToArray(snapshot)

          //Grab the submissions for each appointment
          appointmentsArray.forEach(function(app, appindex){
            let appUid = app.uid
            state.submissions.forEach(function(sub, subindex){
              if(sub.uid==appUid)
                appointmentsArray[appindex].submission = sub
            })
          })

          commit('setAppointments', appointmentsArray)
          
          console.log('Appointments loaded', appointmentsArray)
          resolve()
        })
      })
    },

    // SUBMISSIONS
    fetchSubmissions({commit}) {
      return new Promise(function(resolve, reject) {
        console.log('Fetching Submissions...')
        firebase.database().ref('submissions').on('value', snapshot => {
          //convert subsmissions from firebase to local array (utility function)
          let submissionsArray = snapshotToArray(snapshot)
          let cleanedSubmissionsArray = []
          
          // remove any submissions from the data table with incomplete data
          cleanedSubmissionsArray = submissionsArray.filter(function(sub){
            if( !sub.reg || 
              !sub.make || 
              !sub.model || 
              !sub.firstName || 
              !sub.surname || 
              !sub.tel || 
              !sub.status ||
              !sub.updated ||
              !sub.created) {
                console.log('missing data @ ID: '+sub.uid)
                return false
              } else {
                return true
              }
          });

          commit('setSubmissions', cleanedSubmissionsArray)
          //commit('setSubmission', submissionsArray[0])
          console.log('Submissions loaded', submissionsArray)
          resolve()
        })
      })
    },
    updateSubmissionToFirebase({commit, getters}, payload) {
      //convert local array to object and set in Firebase
      //update will trickle back and mutate local submissions because of .on in fetchSubmissions
      let uid = payload.uid
      let ts = firebase.database.ServerValue.TIMESTAMP;
      payload.updated = ts
      payload.user = getters.user.uid
      firebase.database().ref('submissions/' + uid).set(payload)
        .then(() => {
          console.log('Updating submission ' + uid + 'succeeded');
        })
        .catch(error => {
          console.log('Updating submission ' + uid + 'failed');
        })
    },
    setSubmissionStatus({commit}, payload) {
      commit('setSubmissionStatus', payload)
    }, 
    setTempSubmissionStatus({commit}, payload) {
      commit('setTempSubmissionStatus', payload)
    }, 
    setSubmission({commit}, payload) {
      commit('setSubmission', payload)
    },
    unsetSubmission({commit}) {
      commit('unsetSubmission')
    },
    
    // NOTES
    fetchNotes({commit}, payload) {
      return new Promise(function(resolve, reject) {
        console.log('Fetching Notes for submission UID:'+payload+'...')
        firebase.database().ref('notes/' + payload).on('value', snapshot => {
          commit('setNotes', snapshot.val())   
          console.log('Notes loaded', snapshot.val())
          scrollNotesToBottom()
          resolve()
        })
      })  
    },
    unsetNotes({commit}, payload) {
      commit('unsetNotes', payload)
    },
    addNote({commit}, payload) {
      commit('addNote', payload)
      scrollNotesToBottom()
    },

    // OFFERS
    fetchOffers({commit}, payload) {
      return new Promise(function(resolve, reject) {
        console.log('Fetching Offers for submission UID:'+payload+'...')
        firebase.database().ref('offers/' + payload).on('value', snapshot => {
          commit('setOffers', snapshot.val())   
          console.log('Offers loaded', snapshot.val())
          resolve()
        })
      })  
    },
    unsetOffers({commit}, payload) {
      commit('unsetOffers', payload)
    },
    addOffer({commit}, payload) {
      commit('addOffer', payload)

      //let emailtext = payload.emailText
    
      // contact php to send an email to the lucky customer 
      axios.get('https://webeatweb.com/m4capi/sg-send-templated.php?origin=m4cForm&fname='+payload.firstName
        +'&surname='+payload.surname
        +'&email='+payload.email
        +'&tel='+payload.tel
        +'&reg='+payload.reg
        +'&make='+payload.make
        +'&model='+payload.model
        +'&offeramount='+payload.amount
        +'&expirydays='+payload.days
        +'&expirydate='+payload.expires
        +'&appointurl='+payload.appointUrl
        +'&stage=offer&templateid=d-9d53491a5bb4490ea5d3441c83187d8d'
        )
      .then((resp) => { 
        console.log(resp)
      })
      .catch((error) => { console.log('Sending the offer by email to the customer FAILED: ',error) })
    },
    noShowActivated({getters}, payload) {
      // contact php to send an email to the lucky customer who didn't turn up
      
      //get the appointment date and time from FB > appointments for this submission
      firebase.database().ref('appointments/' + getters.submission.uid).once('value', snapshot => {
        
          let appointment = snapshot.val()
          if(appointment) {
            axios.get('https://webeatweb.com/m4capi/sg-send-templated.php?origin=m4cForm&fname='+payload.firstName
            +'&surname='+payload.surname
            +'&email='+payload.email
            +'&appointurl='+payload.appointUrl
            +'&appointdate='+appointment.date
            +'&appointtime='+appointment.time
            +'&stage=reschedule&templateid=d-836706d678c74b7c8c824e865d317eaf'
            )
          .then((resp) => { 
            console.log(resp)
          })
          .catch((error) => { console.log('Sending the reschedule email to the customer FAILED: ',error) })
        } else {
          alert('There was no appointment booked for this submission\nSo no email has been sent to the customer.')
        }
        //resolve()
      })//.bind(payload) // <-- for passing the payload into the FB promise
      
      
      
    },

    // USERS
    fetchUser({commit}, payload) {  //not used (yet)
      return new Promise(function(resolve, reject) {
        console.log('Fetching User')
        firebase.database().ref('users/' + payload).once('value', snapshot => {
          //commit('setUser', snapshot.val())
          console.log('User loaded', snapshot.val())
          resolve()
        }) 
      })
    },
    fetchUsers({commit}) {
      return new Promise(function(resolve, reject) {
        console.log('Fetching users...')
        firebase.database().ref('users').on('value', snapshot => {
          commit('setUsers', snapshot.val())   
          console.log('Users loaded', snapshot.val())
          resolve()
        })
      })  
    },
    
    addUserToFirebase({commit}, payload) {
      return new Promise(function(resolve, reject) {
        console.log('Adding a new user to DB')
      
        // Create new endpoint key in Firebase
        //let payloadKey = firebase.database().ref('users').push().key
      
        // Add the key to the user obj
        //payload.key = payloadKey;
      
        let uid = payload.uid

        // SET
        firebase.database().ref('users/' + uid).set(payload)
          .then(() => {
            console.log('Adding user succeeded');
            // mutate local user state
            commit('setUser', payload)
            resolve()
          })
          .catch(error => {
            console.log('Adding user failed');
            reject()
        })
        
      })  
        /*
        let updates = {}
        updates['/users/' + payloadKey] = payload
        let result = firebase.database().ref().update(updates)
        console.log('Commited to FB: ', result)*/
   
    },
    updateUserToFirebase({commit}, payload) {

      // Get the firebase key from user state
      let key = payload.uid;

      firebase.database().ref('users/' + key).set(payload)
        .then(() => {
          console.log('Updating user succeeded');

          // mutate local user
          commit('setUser', payload)
        })
        .catch(error => {
          console.log('Updating user failed');
        })

    },
    uploadUserPic({commit, dispatch}, payload) {
      commit('setUploading', true)

      // maybe store selected file's name - this.selectedFile.name
      //eg. this.$store.dispatch('setLeadUpload', this.selectedFile.name)
      let storage = firebase.storage();
      let storageRef = storage.ref();
      let uploadTask = storageRef.child('images/' + payload.name).put(payload);

     
      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on('state_changed', function(snapshot) {

        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let progress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100

        // Set progress for display in view
        commit('setUploadProgress', progress) 
        console.log('Upload is ' + progress + '% done');
      
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused');
          break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running');
          break;
        }
      }, 
      function(error) {
        // Handle unsuccessful uploading
        console.log('There was an error uploading...', error)

      },
      function(){ 
          // Successful upload complete
          console.log('Successful file upload')
          commit('setUploading', false)
          uploadTask.snapshot.ref.getDownloadURL().then( function(downloadURL) {
              console.log('File available at', downloadURL)
              commit('setAvatarUrl', downloadURL)
              dispatch('setUserAvatar', downloadURL)
          })
      })

    },
    setUserAvatar({commit, dispatch, getters}, payload) {
      var user = getters.user
      user.picUrl = payload
      console.log('Updating User avatar...')
      dispatch('updateUserToFirebase', user)
    },
    signUserUp ({commit, dispatch}, payload){ // {commit} is 'argument destructuring' instead of using a context. state can be passed in the obj too
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          result => {
            commit('setLoading', false)
            let newUser = {
              uid: result.user.uid,
              email: payload.email,
              username: payload.username
              //add name + other details
            }
            // add new user to users in firebase
            dispatch('addUserToFirebase', newUser).then(function(){
              dispatch('fetchUsers')
              dispatch('fetchSubmissions').then(function(){
                commit('setLoading', false)
              })
              commit('setUser', newUser)
            })
            
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error) 
            console.log(error)
          }
        )
    },
    login ({commit, dispatch, getters}, payload){ // {commit} is 'argument destructuring' instead of using a context. state can be passed in the obj too
   
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          result => {
            let uid = result.user.uid
            dispatch('fetchUsers')
              .then(function(){
                commit('setUser', getters.users[uid])
                dispatch('fetchSubmissions').then(function(){
                  dispatch('fetchAppointments')
                  commit('setLoading', false)
                })
              })
          }
        )
        .catch(
          error => {
            commit('setLoading', false)
            commit('setError', error)
            console.log(error)
          }
        )
    },
    logout ({commit}) {
      // disconnect firebase listeners
      firebase.database().ref('users').off('value')
      firebase.database().ref('appointments').off('value')
      firebase.database().ref('submissions').off('value')
      firebase.database().ref('notes').off('value')
      firebase.auth().signOut()
      commit('setUser', null)
    },
    clearError({commit}) {
      commit('clearError')
    }
  },
})

// Util functions
function scrollNotesToBottom() {
  setTimeout(function(){
    let notesCard = document.getElementById('notes')
    notesCard.scrollTop = notesCard.scrollHeight
  }, 600)
}

function snapshotToArray(snapshot) {
  var returnArr = [];

  snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;

      returnArr.push(item);
  });

  return returnArr;
};